module.exports = __webpack_public_path__ + "img/1.ed46d070.jpg";